export default {"src":"/_next/static/media/apiKey.3e230bc6.svg","height":17,"width":18};